/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconScubaDivingTank = createReactComponent("outline", "scuba-diving-tank", "IconScubaDivingTank", [["path", { "d": "M8 11a4 4 0 1 1 8 0v5h-8z", "key": "svg-0" }], ["path", { "d": "M8 16v3a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-3", "key": "svg-1" }], ["path", { "d": "M9 4h6", "key": "svg-2" }], ["path", { "d": "M12 7v-3", "key": "svg-3" }], ["path", { "d": "M8 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["circle", { "cx": "12", "cy": "4", "r": ".5", "fill": "currentColor", "key": "svg-5" }]]);

export { IconScubaDivingTank as default };
//# sourceMappingURL=IconScubaDivingTank.mjs.map
